import React, { useEffect, useState } from 'react';
import { generateReclamoPDF } from '../../../components/generateReclamoPDF';
import { Container, Table, Button, Badge, Alert, Spinner, Modal, Form, Pagination } from 'react-bootstrap';
import { FaCheck, FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import AdminRes from '../components/AdminRes';
import { BsInfoCircle } from 'react-icons/bs'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../styles/adminReclamos.css';

const AdminReclamos = () => {
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
    const [reclamos, setReclamos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [successMsg, setSuccessMsg] = useState(null);
    const [adminData, setAdminData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [reciboActual, setReciboActual] = useState(null);
    const [obsRes, setObsRes] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('pendientes');
    const [showModalResolucion, setShowModalResolucion] = useState(false);
    const [resolucionSeleccionada, setResolucionSeleccionada] = useState(null);
    const [showModalEditarResolucion, setShowModalEditarResolucion] = useState(false);
    const [nuevaObsRes, setNuevaObsRes] = useState('');
    
    // Paginación
    const ITEMS_POR_PAGINA = 15;
    const [paginaActual, setPaginaActual] = useState(1);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setAdminData(JSON.parse(storedUser));
        }
    }, []);

    const fetchReclamos = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) throw new Error('Token no encontrado. Inicie sesión nuevamente.');

            let params = {
                mes: '99/9999',
                legajo: 0,
                nFirmado: 1,
                nValidado: null,
                nProtestado: null,
                nResuelto: null
            };

            if (filtroEstado === 'pendientes') {
                params.nProtestado = 1;
                params.nResuelto = 0;
            } else if (filtroEstado === 'resueltos') {
                // Protestas resueltas (Resuelto=1, Valida=0) - cuando se resuelve, Protesta vuelve a 0
                params.nResuelto = 1;
                params.nValidado = 0;
            } else if (filtroEstado === 'validados') {
                // Validados y cerrados (Resuelto=1, Valida=1)
                params.nResuelto = 1;
                params.nValidado = 1;
            }

            const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:4004' : '';
            const response = await axios.get(`${API_URL}/api/reclamos`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const datos = response.data.data || response.data;
            setReclamos(datos);
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || err.message || 'Error al obtener los reclamos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (adminData) {
            fetchReclamos();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adminData, filtroEstado]);

    const formatFecha = (fechaStr) => {
        if (!fechaStr) return 'No disponible';

        try {
            // Intentar crear fecha directamente
            let dateObj = new Date(fechaStr);
            
            // Si la fecha es inválida, intentar parsear formato DD-MM-YYYY HH:MM:SS
            if (isNaN(dateObj.getTime()) && typeof fechaStr === 'string') {
                const [datePart, timePart] = fechaStr.split(' ');
                if (datePart && timePart) {
                    const [day, month, year] = datePart.split('-');
                    dateObj = new Date(`${year}-${month}-${day}T${timePart}`);
                }
            }

            // Si aún es inválida, retornar "No disponible"
            if (isNaN(dateObj.getTime())) return 'No disponible';

            return dateObj.toLocaleString('es-AR', {
                hour12: false,
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        } catch (error) {
            console.error('Error formateando fecha:', fechaStr, error);
            return 'No disponible';
        }
    };

    const verReclamoPDF = async (recibo) => {
        try {
            console.log('📋 Datos del recibo recibidos:', recibo);
            console.log('🖊️ Firma disponible?:', recibo.Firma ? 'SÍ' : 'NO');
            if (recibo.Firma) {
                console.log('🖊️ Firma (primeros 100 chars):', recibo.Firma.substring(0, 100));
            }
            
            // Los datos ya vienen del backend con el JOIN
            const datosReclamo = {
                legajo: recibo.Legajo,
                nombre: recibo.nombre || recibo.NmEmpleado || 'Nombre no disponible',
                mes: recibo.Mes,
                secuencia: recibo.Secuencia,
                motivo: recibo.motivo || recibo.ObsProt || 'Motivo no especificado',
                firmaBase64: recibo.Firma,
                fechaProtesta: recibo.FechaProt || recibo.FechaProtesta,
            };

            console.log('📤 Datos para el PDF:', datosReclamo);
            console.log('📤 Firma en datosReclamo?:', datosReclamo.firmaBase64 ? 'SÍ' : 'NO');

            const { url } = await generateReclamoPDF(datosReclamo);
            window.open(url, '_blank');
        } catch (error) {
            console.error('Error completo al generar PDF:', error);
            setError(`Error generando PDF: ${error.message}`);
        }
    };

    const abrirModal = (recibo) => {
        setReciboActual(recibo);
        setObsRes('');
        setShowModal(true);
    };

    const abrirModalEditarResolucion = (recibo) => {
        setReciboActual(recibo);
        setNuevaObsRes(recibo.ObsRes || '');
        setShowModalEditarResolucion(true);
    };

    const enviarResolucion = async () => {
        if (!reciboActual || !adminData) return;

        try {
            setLoading(true);
            setError(null);
            setShowModal(false);

            const token = localStorage.getItem('token');
            if (!token) throw new Error('Token no encontrado');
            
            // Usar el endpoint migrado de procesos
            await axios.post(
                `${API_URL}/api/procesos/resolver`,
                { 
                    mes: reciboActual.Mes,
                    secuencia: reciboActual.Secuencia,
                    legajo: reciboActual.Legajo,
                    observaciones: obsRes || 'Resuelto sin observaciones'
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setSuccessMsg('Reclamo resuelto correctamente');
            fetchReclamos();
        } catch (err) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
            setReciboActual(null);
        }
    };

    const editarResolucion = async () => {
        if (!reciboActual || !adminData) return;

        try {
            setLoading(true);
            setError(null);
            setShowModalEditarResolucion(false);

            const token = localStorage.getItem('token');
            if (!token) throw new Error('Token no encontrado');

            const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:4004' : '';

            await axios.put(
                `${API_URL}/api/reclamos/${reciboActual.Mes}/${reciboActual.Secuencia}/${reciboActual.Legajo}/editar-resolucion`,
                { observaciones: nuevaObsRes },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setSuccessMsg('Resolución actualizada correctamente');
            fetchReclamos();
        } catch (err) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
            setReciboActual(null);
        }
    };

    const eliminarResolucion = async (recibo) => {
        if (!window.confirm('¿Está seguro de que desea eliminar la resolución y volver el estado a pendiente?')) {
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) throw new Error('Token no encontrado');

            // Revertir el estado: Protesta = 1, Resuelto = 0
            const datosProtesta = {
                Legajo: recibo.Legajo,
                Mes: recibo.Mes,
                Secuencia: recibo.Secuencia,
                Protesta: 1,
                ObsProt: recibo.ObsProt,
            };

            await axios.post(`${API_URL}/api/procesos/protestar`, datosProtesta, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Eliminar la resolución (establecer Resuelto = 0)
            const datosResuelto = {
                legajo: recibo.Legajo,
                mes: recibo.Mes,
                secuencia: recibo.Secuencia,
                Resuelto: 0,
                usrRes: '',
                obsRes: '',
            };

            await axios.post(`${API_URL}/api/procesos/resuelto`, datosResuelto, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setSuccessMsg('Resolución eliminada. El reclamo volvió a estado pendiente.');
            fetchReclamos();
        } catch (err) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    };

    const verResolucion = (recibo) => {
        setResolucionSeleccionada(recibo);
        setShowModalResolucion(true);
    };

    return (
        <Container fluid className="admin-reclamos-container">
            <h2 className="mb-4">Gestión de Reclamos</h2>

            {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
            {successMsg && <Alert variant="success" dismissible onClose={() => setSuccessMsg(null)}>{successMsg}</Alert>}

            <Form.Select
                className="mb-3"
                value={filtroEstado}
                onChange={(e) => {
                    setFiltroEstado(e.target.value);
                    setPaginaActual(1); // Reset a página 1 cuando cambia el filtro
                }}
            >
                <option value="pendientes">Pendientes</option>
                <option value="resueltos">Resueltos</option>
                <option value="validados">Validados</option>
            </Form.Select>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" role="status" />
                    <p>Cargando reclamos...</p>
                </div>
            ) : (
                <>
                    {reclamos.length === 0 ? (
                        <Alert variant="info">No hay reclamos para mostrar.</Alert>
                    ) : (() => {
                        const totalPaginas = Math.ceil(reclamos.length / ITEMS_POR_PAGINA);
                        const inicio = (paginaActual - 1) * ITEMS_POR_PAGINA;
                        const reclamosPaginados = reclamos.slice(inicio, inicio + ITEMS_POR_PAGINA);

                        return (
                            <>
                                <Table striped bordered hover responsive className="mt-3">
                                    <thead>
                                        <tr>
                                            <th>Legajo</th>
                                            <th>Mes</th>
                                            <th>Secuencia</th>
                                            <th>Fecha</th>
                                            <th>Estado</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reclamosPaginados.map((recibo, index) => (
                                    <tr key={index}>
                                        <td>{recibo.Legajo}</td>
                                        <td>{recibo.Mes}</td>
                                        <td>{recibo.Secuencia}</td>
                                        <td>
                                            {filtroEstado === 'pendientes' && formatFecha(recibo.FechaProt)}
                                            {filtroEstado === 'resueltos' && formatFecha(recibo.FechaRes)}
                                            {filtroEstado === 'validados' && formatFecha(recibo.FechaVal)}
                                        </td>
                                        <td>
                                            <Badge bg={
                                                recibo.Valida === 1
                                                    ? 'info'
                                                    : recibo.Resuelto === 1
                                                    ? 'success'
                                                    : 'warning'
                                            }>
                                                {
                                                    recibo.Valida === 1
                                                        ? 'Validado'
                                                        : recibo.Resuelto === 1
                                                        ? 'Resuelto'
                                                        : 'Pendiente'
                                                }
                                            </Badge>
                                        </td>
                                        <td>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Ver Reclamo</Tooltip>}>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => verReclamoPDF(recibo)}
                                                    className="me-2"
                                                >
                                                    <FaEye className="me-1" />
                                                </Button>
                                            </OverlayTrigger>
                                            {recibo.Resuelto !== 1 && recibo.Valida !== 1 && (
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Resolver Reclamo</Tooltip>}>
                                                    <Button
                                                        variant="success"
                                                        size="sm"
                                                        onClick={() => abrirModal(recibo)}
                                                        disabled={loading}
                                                    >
                                                        <FaCheck className="me-1" />
                                                    </Button>
                                                </OverlayTrigger>
                                            )}
                                            {(recibo.Resuelto === 1 || recibo.Valida === 1) && (
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Ver Resolución</Tooltip>}>
                                                    <Button
                                                        variant="info"
                                                        size="sm"
                                                        className="me-2"
                                                        onClick={() => verResolucion(recibo)}
                                                    >
                                                        <BsInfoCircle />
                                                    </Button>
                                                </OverlayTrigger>
                                            )}
                                            {recibo.Resuelto === 1 && recibo.Valida !== 1 && (
                                                <>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Editar Resolución</Tooltip>}>
                                                        <Button
                                                            variant="warning"
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => abrirModalEditarResolucion(recibo)}
                                                        >
                                                            <FaEdit />
                                                        </Button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Eliminar Resolución</Tooltip>}>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => eliminarResolucion(recibo)}
                                                        >
                                                            <FaTrash />
                                                        </Button>
                                                    </OverlayTrigger>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {/* Paginación */}
                        {totalPaginas > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span className="text-muted small">
                                    Mostrando {inicio + 1} - {Math.min(inicio + ITEMS_POR_PAGINA, reclamos.length)} de {reclamos.length}
                                </span>
                                <Pagination className="mb-0">
                                    <Pagination.First 
                                        onClick={() => setPaginaActual(1)} 
                                        disabled={paginaActual === 1} 
                                    />
                                    <Pagination.Prev 
                                        onClick={() => setPaginaActual(p => Math.max(1, p - 1))} 
                                        disabled={paginaActual === 1} 
                                    />
                                    
                                    {[...Array(Math.min(5, totalPaginas))].map((_, i) => {
                                        let pageNum;
                                        if (totalPaginas <= 5) {
                                            pageNum = i + 1;
                                        } else if (paginaActual <= 3) {
                                            pageNum = i + 1;
                                        } else if (paginaActual >= totalPaginas - 2) {
                                            pageNum = totalPaginas - 4 + i;
                                        } else {
                                            pageNum = paginaActual - 2 + i;
                                        }
                                        
                                        return (
                                            <Pagination.Item
                                                key={pageNum}
                                                active={pageNum === paginaActual}
                                                onClick={() => setPaginaActual(pageNum)}
                                            >
                                                {pageNum}
                                            </Pagination.Item>
                                        );
                                    })}
                                    
                                    <Pagination.Next 
                                        onClick={() => setPaginaActual(p => Math.min(totalPaginas, p + 1))} 
                                        disabled={paginaActual === totalPaginas} 
                                    />
                                    <Pagination.Last 
                                        onClick={() => setPaginaActual(totalPaginas)} 
                                        disabled={paginaActual === totalPaginas} 
                                    />
                                </Pagination>
                            </div>
                        )}
                            </>
                        );
                    })()}
                </>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Resolver Reclamo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {reciboActual && (
                        <div className="mb-4">
                            <h5 className="border-bottom pb-2 mb-3">Información del Reclamo</h5>
                            
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Legajo:</strong> {reciboActual.Legajo}
                                </div>
                                <div className="col-md-6">
                                    <strong>Empleado:</strong> {reciboActual.nombre || reciboActual.NmEmpleado || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <strong>Mes:</strong> {reciboActual.Mes}
                                </div>
                                <div className="col-md-6">
                                    <strong>Secuencia:</strong> {reciboActual.Secuencia}
                                </div>
                            </div>
                            
                            <div className="mb-3">
                                <strong>Fecha del Reclamo:</strong> {formatFecha(reciboActual.FechaProt)}
                            </div>
                            
                            <div className="mb-3">
                                <strong>Motivo del Reclamo:</strong>
                                <div className="alert alert-light mt-2">
                                    {reciboActual.motivo || reciboActual.ObsProt || 'Sin motivo especificado'}
                                </div>
                            </div>
                            
                            {reciboActual.Firma && (
                                <div className="mb-3">
                                    <strong>Firma del Empleado:</strong>
                                    <div className="border rounded p-2 mt-2 bg-light text-center">
                                        <img 
                                            src={`data:image/png;base64,${reciboActual.Firma}`}
                                            alt="Firma"
                                            style={{ maxWidth: '200px', maxHeight: '100px' }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    
                    <Form.Group controlId="obsRes">
                        <Form.Label><strong>Resolución del Reclamo</strong></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={obsRes}
                            onChange={(e) => setObsRes(e.target.value)}
                            placeholder="Ingrese la resolución del reclamo y las acciones tomadas..."
                        />
                        <Form.Text className="text-muted">
                            Este mensaje será visible para el empleado.
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
                    <Button variant="success" onClick={enviarResolucion}>
                        <FaCheck className="me-1" /> Resolver Reclamo
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalEditarResolucion} onHide={() => setShowModalEditarResolucion(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Resolución</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="nuevaObsRes">
                        <Form.Label>Nuevo mensaje de resolución</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={nuevaObsRes}
                            onChange={(e) => setNuevaObsRes(e.target.value)}
                            placeholder="Edite el comentario para el empleado..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalEditarResolucion(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={editarResolucion}>Guardar Cambios</Button>
                </Modal.Footer>
            </Modal>

            <AdminRes
                show={showModalResolucion}
                onHide={() => setShowModalResolucion(false)}
                resolucion={resolucionSeleccionada}
            />
        </Container>
    );
};

export default AdminReclamos;